/******************************************************************************
 *
 * WorkChecklistCard
 *
 * Displays Checklist execution summary.
 *
 * Future
 *
 * - Checklist execution
 * - Mandatory validation
 * - Checklist progress
 * - Open checklist page
 *
 ******************************************************************************/

import React from "react";

export default function WorkChecklistCard({

    checklists = [],

    onOpenChecklist

}) {

    const total = checklists.length;

    const completed = checklists.filter(

        item => item.status === "COMPLETED"

    ).length;

    const pending = total - completed;

    const mandatory = checklists.filter(

        item => item.is_mandatory

    ).length;

    const optional = total - mandatory;

    const percentage =

        total === 0

            ? 0

            : Math.round(

                (completed / total) * 100

            );

    return (

        <div className="card border-0 shadow-sm h-100">

            <div className="card-header bg-white">

                <div className="d-flex justify-content-between align-items-center">

                    <h5 className="mb-0">

                        ✅ Checklist Summary

                    </h5>

                    <span className="badge bg-primary">

                        {total} Items

                    </span>

                </div>

            </div>

            <div className="card-body">

                {/* Progress */}

                <div className="mb-4">

                    <div className="d-flex justify-content-between mb-2">

                        <span>

                            Completion

                        </span>

                        <strong>

                            {percentage}%

                        </strong>

                    </div>

                    <div className="progress" style={{ height: 10 }}>

                        <div
                            className="progress-bar bg-success"
                            style={{
                                width: `${percentage}%`
                            }}
                        />

                    </div>

                </div>

                {/* Statistics */}

                <div className="row text-center g-3">

                    <div className="col-6">

                        <div className="border rounded p-3">

                            <h4 className="text-success mb-1">

                                {completed}

                            </h4>

                            <small className="text-muted">

                                Completed

                            </small>

                        </div>

                    </div>

                    <div className="col-6">

                        <div className="border rounded p-3">

                            <h4 className="text-warning mb-1">

                                {pending}

                            </h4>

                            <small className="text-muted">

                                Pending

                            </small>

                        </div>

                    </div>

                    <div className="col-6">

                        <div className="border rounded p-3">

                            <h4 className="text-danger mb-1">

                                {mandatory}

                            </h4>

                            <small className="text-muted">

                                Mandatory

                            </small>

                        </div>

                    </div>

                    <div className="col-6">

                        <div className="border rounded p-3">

                            <h4 className="text-info mb-1">

                                {optional}

                            </h4>

                            <small className="text-muted">

                                Optional

                            </small>

                        </div>

                    </div>

                </div>

                <hr />

                {/* Status */}

                {

                    total === 0 && (

                        <div className="alert alert-light border text-center">

                            No checklist available for this work.

                        </div>

                    )

                }

                {

                    total > 0 && (

                        <div className="alert alert-success">

                            {

                                completed === total

                                    ?

                                    "Checklist completed."

                                    :

                                    `${pending} checklist item(s) pending.`

                            }

                        </div>

                    )

                }

                {/* Action */}

                <div className="d-grid">

                    <button
                        className="btn btn-primary"
                        onClick={onOpenChecklist}
                    >

                        Open Checklist

                    </button>

                </div>

            </div>

        </div>

    );

}